import SignUpForm from "../../components/SignUpForm.js";
import SEOHead from "../../components/SEO/SEOHead";

export default function SignUP() {
  return (
    <div>
      <SEOHead
        title="Sign up - Bowling Tournament App"
        description="Create a Bowling Tournament App account."
        canonicalUrl="/signup"
        noIndex
      />
      <SignUpForm />
    </div>
  );
}
